import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Modal } from "@faire/web--source/slate/Modal";
import { Spacer } from "@faire/web--source/slate/spacing";
import { Typography } from "@faire/web--source/slate/Typography";
import { useViewport } from "@faire/web--source/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { trackRetailerTeamSharingInviteUserLeanFlowClick } from "@faire/web-api--source/events/retailerTeamSharing/click/inviteUserLeanFlow";
import React from "react";
import { InviteTeamMemberSection } from "@faire/retailer-visitor-shared/views/multi-user/Invite/InviteTeamMemberSection";
import { PageName } from "@faire/retailer-visitor-shared/views/multi-user/Share/consts";
export var LeanInviteTeamModal = function(param) {
    var onInvite = param.onInvite, onBack = param.onBack, onClose = param.onClose, pageName = param.pageName;
    var viewport = useViewport();
    var strictLocalize = useStrictLocalization().strictLocalize;
    var getModalDescriptionFromPage = function(pageName) {
        switch(pageName){
            case PageName.ORDER:
                return strictLocalize({
                    id: "RF/+6V",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Team members can help you track orders and can be automatically kept in the loop on order updates."
                        }
                    ]
                });
            case PageName.INVOICE:
                return strictLocalize({
                    id: "1BuvmQ",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Team members can access invoices to help with tracking or payments."
                        }
                    ]
                });
            case PageName.BRAND:
                return strictLocalize({
                    id: "Qt9Mta",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Team members can view full brand details."
                        }
                    ]
                });
            case PageName.PDP:
            default:
                return strictLocalize({
                    id: "7XF5Yr",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Team members can view full product details."
                        }
                    ]
                });
        }
    };
    return /*#__PURE__*/ _jsxs(Modal, {
        padding: "88px 24px 24px 24px",
        width: viewport.isTabletAndAbove ? "420px" : undefined,
        onClose: onClose,
        onBack: onBack,
        align: "stretch",
        "data-test-id": "lean-invite-team-modal",
        children: [
            /*#__PURE__*/ _jsx(Typography, {
                variant: "pageHeaderSerifRegular",
                children: /*#__PURE__*/ _jsx(StrictLocalMsg, {
                    id: "o0umuH",
                    defaultMessage: [
                        {
                            type: 0,
                            value: "Invite a team member"
                        }
                    ]
                })
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: getModalDescriptionFromPage(pageName)
            }),
            /*#__PURE__*/ _jsx(Spacer, {
                height: "2x"
            }),
            /*#__PURE__*/ _jsx(InviteTeamMemberSection, {
                onInviteSent: onInvite,
                onInviteButtonClick: function() {
                    return trackRetailerTeamSharingInviteUserLeanFlowClick(pageName);
                }
            })
        ]
    });
};
